// 导入封装好的axios实例
import request from './request'

const http ={
    /**
     * methods: 请求
     * @param url 请求地址
     * @param params 请求参数
     */
    get(url,params){
      const config = {
        method: 'get',
        url:url
      }
      if(params) config.params = params
      return request(config)

      // if (params instanceof FormData) {
      //   baseConfig.data = params;
      //   // 注意：不要手动设置Content-Type，让浏览器自动添加boundary
      //   baseConfig.headers = {
      //     ...config.headers,
      //     'Content-Type': 'multipart/form-data'
      //   };
      // } else {
      //   baseConfig.data = params;
      // }
      // return request({...baseConfig, ...config});
    },
    post(url,params){
      const config = {
        method: 'post',
        url:url
      }
      if(params) config.data = params
      return request(config)
    },
    put(url,params){
        const config = {
            method: 'put',
            url:url
        }
        if(params) config.params = params
        return request(config)
    },
    delete(url,params){
        const config = {
            method: 'delete',
            url:url
        }
        if(params) config.params = params
        return request(config)
    }
}
//导出
export default http


// WEBPACK FOOTER //
// ./src/utils/http.js